import {
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from "@angular/forms";
import { CheckboxComponent } from "@components/checkbox/checkbox.component";
import { BlockComponent } from "@components/container-block/block.component";
import { FormBinderService } from "~app/common/services/form-binder.service";
import { ProduktdefinitionViewModel } from "../../../models/ProduktdefinitionViewModel";

@Component({
    selector: "rask-restriktioner",
    templateUrl: "./restriktioner.component.html",
    styleUrls: ["./restriktioner.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        BlockComponent,
        FormsModule,
        ReactiveFormsModule,
        CheckboxComponent
    ]
})
export class RestriktionerComponent implements OnInit, OnChanges {
    form: UntypedFormGroup;
    @Input() rootForm: UntypedFormGroup;
    @Input() viewModel: ProduktdefinitionViewModel;

    private readonly formBinder = inject(FormBinderService);
    private readonly formId = "produktinstruktioner-details-restriktioner";

    ngOnChanges(changes: SimpleChanges): void {
        if (this.form && changes.viewModel && changes.viewModel.currentValue.restriktioner !== changes.viewModel.previousValue.restriktioner) {
            this.formBinder.reBindForm(this.form, this.viewModel.restriktioner);
        }
    }

    ngOnInit(): void {
        this.initializeForm();
    }

    private initializeForm() {
        this.form = this.formBinder.CreateGroup(this.viewModel.restriktioner);
        this.rootForm.addControl(this.formId, this.form);
        if (!this.viewModel.canEdit) {
            this.form.disable();
        } else {
            this.form.enable();
        }
    }
}
